import { render, staticRenderFns } from "./mb-banner.vue?vue&type=template&id=df760d64&scoped=true&"
import script from "./mb-banner.vue?vue&type=script&lang=js&"
export * from "./mb-banner.vue?vue&type=script&lang=js&"
import style0 from "./mb-banner.vue?vue&type=style&index=0&id=df760d64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df760d64",
  null
  
)

export default component.exports